/* RESPONSIBLE TEAM: team-standalone */
import WorkflowsEditRoute from 'embercom/routes/apps/app/automation/workflows/edit';
export default WorkflowsEditRoute;
